import { render } from "./NewsletterSVG.vue?vue&type=template&id=5ca6cec7"
import script from "./NewsletterSVG.vue?vue&type=script&lang=js"
export * from "./NewsletterSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__